var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { CustomElement, P, PCSS, Watch, PropertyConverters, Utils, PropertyChangeEventName, Components, avoidHandler } from '@pacem/pacem-core';
import { Components as UIComponents } from '@pacem/pacem-ui';
import { Components as ScaffoldingComponents } from '@pacem/pacem-scaffolding';
const UI = UIComponents.UI;
const Scaffolding = ScaffoldingComponents.Scaffolding;
//namespace Pacem.Components.Plus {
export var EditMode;
(function (EditMode) {
    EditMode["Text"] = "text";
    EditMode["Html"] = "html";
    EditMode["Image"] = "image";
    EditMode["Markdown"] = "markdown";
})(EditMode || (EditMode = {}));
let PacemEditElement = class PacemEditElement extends Components.PacemElement {
    constructor(_markdown = new UI.MarkdownService()) {
        super();
        this._markdown = _markdown;
        // #endregion
        // #endregion
        this._dialogPropertyChangedHandler = (evt) => {
            this._dialogPropertyChangedCallback(evt);
        };
        this._broadcastFetchRequestEventName = (evt) => {
            this.dispatchEvent(new Scaffolding.ImageFetchRequestEvent(evt.detail));
        };
        this._innerValueChangedHandler = (evt) => {
            if (evt.detail.propertyName === 'value' && !Utils.isNull(this._dialog))
                this._dialog.state = evt.detail.currentValue;
        };
        this._editHandler = (evt) => {
            this.edit(evt);
        };
    }
    _addButton() {
        /*<pacem-balloon options="{ position: '${UI.BalloonPosition.Top}', align: '${UI.BalloonAlignment.End}', behavior: '${UI.BalloonBehavior.Inert}', hoverDelay: 0 }" disabled="{{ :host.disabled }}" class="pacem-edit-balloon">
            <pacem-button class="pacem-edit" on-click=":host.edit($event)"></pacem-button>
        </pacem-balloon>*/
        if (!Utils.isNull(this._button))
            return;
        //
        var btn = document.createElement(P + '-button');
        btn.className = PCSS + '-edit-button';
        btn.addEventListener('click', this._editHandler, false);
        this._target.appendChild(btn);
        //
        return this._button = btn;
    }
    _removeButton() {
        var btn = this._button;
        if (Utils.isNull(btn))
            return;
        btn.removeEventListener('click', this._editHandler, false);
        btn.remove();
        this._button = null;
    }
    // #region dialog
    _addDialog() {
        /* <pacem-dialog buttons="'${ UI.DialogButtons.OkCancel}'" on-${PropertyChangeEventName}=":host._dialogPropertyChangedCallback($event)"> */
        var dialog = document.createElement(P + '-dialog');
        dialog.buttons = UI.DialogButtons.OkCancel;
        dialog.addEventListener(PropertyChangeEventName, this._dialogPropertyChangedHandler, false);
        dialog.appendChild(this._addTextarea());
        dialog.appendChild(this._addContenteditable());
        dialog.appendChild(this._addEditImage());
        document.body.appendChild(dialog);
        //
        return this._dialog = dialog;
    }
    _removeDialog() {
        this._removeTextarea();
        this._removeContenteditable();
        this._removeEditImage();
        if (!Utils.isNull(this._dialog)) {
            this._dialog.removeEventListener(PropertyChangeEventName, this._dialogPropertyChangedHandler, false);
            this._dialog.remove();
        }
    }
    // #region textarea
    _addTextarea() {
        /*<pacem-textarea hide="{{ :host.type === '${ EditMode.Html}' || :host.type === '${EditMode.Image}' }}" value="{{ ::_dialog.state, twoway }}"></pacem-textarea>*/
        var textarea = document.createElement(P + '-textarea');
        textarea.className = PCSS + '-edit-text';
        textarea.addEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
        const type = this.type || EditMode.Text;
        textarea.hide = type !== EditMode.Text && type !== EditMode.Markdown;
        return this._textarea = textarea;
    }
    _removeTextarea() {
        if (!Utils.isNull(this._textarea))
            this._textarea.removeEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
    }
    // #endregion
    // #region contenteditable
    _addContenteditable() {
        /*<pacem-contenteditable hide="{{ :host.type != '${ EditMode.Html}' }}" value="{{ ::_dialog.state, twoway  }}"></pacem-contenteditable> */
        var contenteditable = document.createElement(P + '-contenteditable');
        contenteditable.className = PCSS + '-edit-content';
        contenteditable.addEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
        const type = this.type || EditMode.Text;
        contenteditable.hide = type !== EditMode.Html;
        return this._contenteditable = contenteditable;
    }
    _removeContenteditable() {
        if (!Utils.isNull(this._contenteditable))
            this._contenteditable.removeEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
    }
    // #endregion
    // #region edit-image
    _addEditImage() {
        /*<!-- img -->
<pacem-panel class="pacem-edit-image" hide="{{ :host.type != '${ EditMode.Image}' }}"
    css-class="{{ {'pacem-uploading': ::_uploader.uploading, 'pacem-upload-enabled': !Pacem.Utils.isNullOrEmpty(:host.imageUploadUrl)} }}">
    <pacem-input-search value="{{ :host.hint, twoway }}"></pacem-input-search>
    <pacem-upload pattern="'.+\.(jpe?g|png)$'" url="{{ :host.imageUploadUrl }}" on-${ PropertyChangeEventName}=":host._uploaderPropertyChangedCallback($event)" hide="{{ Pacem.Utils.isNullOrEmpty(:host.imageUploadUrl) }}"></pacem-upload>
    <pacem-infinite-scroller container="{{ ::_repeater }}" on-fetchmore=":host._imagefetchSuddenly()" disabled="{{ :host._fetching || !:host._open || :host._images.length >= :host.imageSet.total }}"></pacem-infinite-scroller>
    <pacem-repeater datasource="{{ :host._images }}">
        <template>
            <pacem-img css-class="{{ {'pacem-selected': ^item.src === ::_dialog.state } }}" on-click="::_dialog.state = ^item.src" src="{{ ^item.thumb }}" adapt="'contain'"></pacem-img>
        </template>
    </pacem-repeater>
    <pacem-progressbar></pacem-progressbar>
</pacem-panel>*/
        var editImage = document.createElement(P + '-edit-image');
        editImage.disabled = true;
        editImage.addEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
        editImage.addEventListener(Scaffolding.ImageFetchRequestEventName, this._broadcastFetchRequestEventName, false);
        const type = this.type || EditMode.Text;
        editImage.hide = type !== EditMode.Image;
        editImage.uploadUrl = this.imageUploadUrl;
        editImage.allowSnapshot = this.allowSnapshot;
        editImage.maxWidth = this.maxImageWidth;
        editImage.maxHeight = this.maxImageHeight;
        return this._editImage = editImage;
    }
    _removeEditImage() {
        if (!Utils.isNull(this._editImage)) {
            this._editImage.removeEventListener(PropertyChangeEventName, this._innerValueChangedHandler, false);
            this._editImage.removeEventListener(Scaffolding.ImageFetchRequestEventName, this._broadcastFetchRequestEventName, false);
        }
    }
    _update(val) {
        var cnt = this._content;
        switch (this.type) {
            case EditMode.Html:
                cnt.innerHTML = val;
                break;
            case EditMode.Markdown:
                switch (cnt.localName) {
                    case P + '-markdown':
                        cnt.value = val;
                        break;
                    default:
                        cnt.innerHTML = this._markdown.toHtml(val);
                        break;
                }
                break;
            case EditMode.Image:
                switch (cnt.localName) {
                    case 'img':
                    case P + '-img':
                        cnt['src'] = val;
                        break;
                    default:
                        cnt.style.backgroundImage = `url(${val})`;
                        break;
                }
                break;
            default:
                this._content.textContent = val;
                break;
        }
    }
    _retrieve() {
        var cnt = this._content;
        switch (this.type) {
            case EditMode.Html:
                return cnt.innerHTML;
            case EditMode.Image:
                switch (cnt.localName) {
                    case P + '-img':
                    case 'img':
                        return cnt['src'];
                    default:
                        let styled = getComputedStyle(cnt).backgroundImage, matches = /url\(["']?([^'"]+)["']?\)/.exec(styled);
                        return matches && matches.length && matches[1];
                }
            case EditMode.Markdown:
                return cnt['value'] || cnt.textContent;
            default:
                return cnt.textContent;
        }
    }
    _setup() {
        const val = this.disabled;
        if (val) {
            Utils.removeClass(this._target, PCSS + '-editing');
            this._removeButton();
        }
        else {
            Utils.addClass(this._target, PCSS + '-editing');
            this._addButton();
        }
    }
    _dialogPropertyChangedCallback(evt) {
        if (evt.detail.propertyName === 'state') {
            const val = evt.detail.currentValue;
            if (!Utils.isNull(this._textarea))
                this._textarea.value = val;
            if (!Utils.isNull(this._contenteditable))
                this._contenteditable.value = val;
            if (!Utils.isNull(this._editImage))
                this._editImage.value = val;
            this._update(evt.detail.currentValue);
        }
    }
    get _target() {
        var cnt = this.target;
        if (Utils.isNull(cnt))
            cnt = this.firstElementChild;
        return cnt;
    }
    connectedCallback() {
        super.connectedCallback();
        this._addDialog();
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this._addButton();
        this._setup();
    }
    disconnectedCallback() {
        this._removeButton();
        this._removeDialog();
        super.disconnectedCallback();
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        switch (name) {
            case 'imageUploadUrl':
                if (!Utils.isNull(this._editImage))
                    this._editImage.uploadUrl = val;
                break;
            case 'allowSnapshot':
                if (!Utils.isNull(this._editImage))
                    this._editImage.allowSnapshot = val;
                break;
            case 'imageSet':
                if (!Utils.isNull(this._editImage))
                    this._editImage.imageSet = val;
                break;
            case 'disabled':
                this._setup();
                break;
            case 'type':
                const type = val;
                if (!Utils.isNull(this._textarea))
                    this._textarea.hide = type !== EditMode.Text && type !== EditMode.Markdown;
                if (!Utils.isNull(this._contenteditable))
                    this._contenteditable.hide = type !== EditMode.Html;
                if (!Utils.isNull(this._editImage))
                    this._editImage.hide = type !== EditMode.Image;
                break;
            case 'maxImageHeight':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxHeight = val;
                break;
            case 'maxImageWidth':
                if (!Utils.isNull(this._editImage))
                    this._editImage.maxWidth = val;
                break;
        }
    }
    edit(evt) {
        avoidHandler(evt);
        var cnt = this._target;
        if (Utils.isNull(cnt))
            return;
        this._removeButton();
        this._content = cnt;
        var state = this._state = this._retrieve();
        if (!Utils.isNull(this._editImage))
            this._editImage.disabled = false;
        this._dialog.open(state).then(args => {
            switch (args.button) {
                case UI.DialogButton.Cancel:
                    // reset value
                    this._update(this._state);
                    break;
                case UI.DialogButton.Ok:
                    // save
                    this._update(args.state);
                    this.dispatchEvent(new CustomEvent('commit', { detail: { value: args.state } }));
                    break;
            }
            this._content = null;
            if (!Utils.isNull(this._editImage))
                this._editImage.disabled = true;
            this._addButton();
        });
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemEditElement.prototype, "key", void 0);
__decorate([
    Watch({ converter: PropertyConverters.String })
], PacemEditElement.prototype, "type", void 0);
__decorate([
    Watch({ converter: PropertyConverters.Element })
], PacemEditElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], PacemEditElement.prototype, "imageUploadUrl", void 0);
__decorate([
    Watch({ emit: false })
], PacemEditElement.prototype, "imageSet", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEditElement.prototype, "maxImageWidth", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], PacemEditElement.prototype, "maxImageHeight", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], PacemEditElement.prototype, "allowSnapshot", void 0);
PacemEditElement = __decorate([
    CustomElement({
        tagName: P + '-edit'
    })
], PacemEditElement);
export { PacemEditElement };
